import React from 'react';
import './blog-post.css';

import gal1 from './pictures/gal1.jpg';
import gal2 from './pictures/gal2.jpg';
import gal3 from './pictures/gal3.jpg';


//import reportWebVitals from './reportWebVitals';

const Galentine = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Galentine's Tabling Recap</h2>
                    <p class="site-post-meta">February 12th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>                   
                    Thank you everyone who stopped by our Galentine’s Day tabling last Monday! 
                    We hope you enjoyed the red velvet cupcakes from Trophy’s Cupcakes and chocolate chip cookies from Hello Robin! 
                    <br></br>
                     
                    </p>
                     <img src={gal1} alt="Officers at with cupcakes and cookies"/>
                     <img src={gal2} alt="Officers at with cupcakes and cookies"/>
                     <img src={gal3} alt="Cupcakes and cookies at tabling"/>
 
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Galentine;

